import { KEVALIN_METRICS_URL } from 'appConstants';
import { RelatedEvent } from 'types';

const KevalinUtils = {
  getRelatedEvents: (
    type: string,
    category: string,
    ids: Array<string>,
    app: string,
  ): Array<RelatedEvent> => {
    return ids.map(
      (id) =>
        ({
          type,
          id,
          category,
          app,
        } as RelatedEvent),
    );
  },
  getKevalinURL: (collectionName: string): string => {
    return KEVALIN_METRICS_URL.replace('{COLLECTION_NAME}', collectionName);
  },
};

export { KevalinUtils };
